import useMembersViewModel from './MembersViewModel'

import ConfirmationModal from '@components/shared/ConfirmationModal'
import { FaTrash } from 'react-icons/fa'
import InviteNewMemberDialog from '@components/shared/Dialogs/InviteNewMemberDialog'
import MemberRoleSwitcher from '@components/settings/Organizations/Members/MemberRoleSwitcher'
import AddNewOrgMemberDialog from '@components/shared/Dialogs/AddExistingOrgMemberDialog'

const Members = () => {
    
    const vm = useMembersViewModel()
    
    if (vm.organizationIsLoading)
        return <div className="absolute-centered loading loading-spinner loading-xs" />
    
    return (
        
        <div className="Members">
            
            {!vm.organization?.members?.length > 0 && (
                <div className="mt-4 card">
                    <div className="card-body">
                        <p>No members yet.</p>
                    </div>
                </div>
            )}
            
            <nav className="todo----real-toolbar flex justify-between gap-2">
                <div className="flex gap-2">
                    <input
                        className="input input-bordered input-sm"
                        type="text"
                        placeholder="Filter members..."
                        value={vm.memberQuery}
                        onChange={e => vm.setMemberQuery(e.target.value?.toLowerCase())}
                        onKeyUp={e => e.key === 'Escape' && vm.setMemberQuery('')} />
                </div>
                {(vm.currentUserOrgJoin?.memberRole === 'owner' || vm.currentUserOrgJoin?.memberRole === 'admin') && (
                    <div className="flex justify-end gap-2">
                        <button
                            className="btn btn-primary"
                            onClick={() => vm.setAddExistingOrgMemberDialogOpen(true)}>
                            Add Member
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => vm.setInviteNewOrgMemberDialogOpen(true)}>
                            Invite New Member
                        </button>
                    </div>
                )}
            </nav>
            
            {vm.organization?.members?.length > 0 && (
                <table className="w-full table-auto mt-6 max-w-screen-lg">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th className="pl-7">Role</th>
                            <th>Status</th>
                            <th>{/* Actions */}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vm.filteredMembers.map(it => (
                            <tr key={`member-${it.id}`}>
                                <td>{it.email}</td>
                                <td>
                                    <MemberRoleSwitcher
                                        currentUserMemberRole={vm.currentUserOrgJoin?.memberRole}
                                        member={it}
                                        onChangeMemberRole={vm.onChangeMemberRole} />
                                </td>
                                <td>
                                    {it.stage !== 'filled' ? (
                                        <i>Invited</i>
                                    ) : (
                                        <span className="text-muted">Joined</span>
                                    )}
                                </td>
                                <td>
                                    <div className="flex items-center content-center justify-end">
                                        {it.id !== vm.user.id && 
                                            (vm.currentUserOrgJoin?.memberRole === 'owner'
                                                || (vm.currentUserOrgJoin?.memberRole === 'admin' && 
                                                    it.UserOrganizationJoin.memberRole === 'member')
                                            ) && (
                                            <button
                                                className="w-auto text-red-800 btn btn-link hover:text-red-500"
                                                title="Remove Member"
                                                onClick={() => vm.setPendingRemoveMember(it)}>
                                                <FaTrash/>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            
            <ConfirmationModal
                showModal={Boolean(vm.pendingRemoveMember)}
                showHideModal={vm.setPendingRemoveMember}
                title="Remove Member"
                message={`Are you sure you want to remove the member "${vm.pendingRemoveMember?.email}"?`}
                onConfirm={vm.onConfirmRemoveMemberClick}/>
            
            <ConfirmationModal
                showModal={vm.confirmChangeOwnerModalOpen}
                showHideModal={() => {
                    vm.setConfirmChangeOwnerModalData(null)
                    vm.setConfirmChangeOwnerModalOpen(false)
                }}
                title="Change Organization Owner"
                message={(<>
                    <p>
                        Organizations can have only one owner. If you want to change the owner, you will need to
                        transfer the organization to the new owner.
                    </p>
                    <p className="mt-4">
                        Are you sure you want to transfer the organization to
                        {' '}
                        <span className="text-accent">
                            {vm.confirmChangeOwnerModalData?.memberEmail}
                        </span>
                        {'?'}
                    </p>
                </>)}
                onConfirm={vm.completeChangeMemberRole} />
            
            <AddNewOrgMemberDialog
                newMemberEmail={vm.newMemberEmail}
                loadingAddMember={vm.loadingAddMember}
                onAddMemberClick={vm.onAddMemberClick}
                onChange={e => vm.setNewMemberEmail(e.target.value)} />
            
            <InviteNewMemberDialog
                inviteMemberFirstName={vm.inviteMemberFirstName}
                loadingInviteMember={vm.loadingInviteMember}
                inviteMemberLastName={vm.inviteMemberLastName}
                inviteMemberEmail={vm.inviteMemberEmail}
                onInviteMemberClick={vm.onInviteMemberClick}
                setInviteMemberFirstName={vm.setInviteMemberFirstName}
                setInviteMemberLastName={vm.setInviteMemberLastName}
                setInviteMemberEmail={vm.setInviteMemberEmail} />
        
        </div>
        
    )
    
}

export default Members
